import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Navigate } from 'react-router-dom';
import LandingPage from './LandingPage';

const ConditionalLandingPage: React.FC = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className='h-full flex items-center justify-center'>
        <div className='text-lg text-gray-600'>Loading...</div>
      </div>
    );
  }

  // If user is logged in, redirect to practice page
  if (user) {
    return (
      <Navigate
        to='/practice'
        replace
      />
    );
  }

  // If user is not logged in, show landing page
  return <LandingPage />;
};

export default ConditionalLandingPage;
